import React from "react";
import MainNavItem from "../MainNavItem";
import DotsLine from "components/common/view_util/DotsLine";
import { useParams } from "react-router-dom";
import MainNavGroup from "../MainNavGroup";
import { NavElement } from "type/navigation/main_navigation.type";
import { DL_GROUP_DESCRIPTION } from "constant/dl_group/dl_group_description.constant";
import { DlGroupSlug } from "constant/dl_group/dl_group.constant";

export default function GroupNavigation() {
  const { slug, groupSlug } = useParams();
  const gSLug = (slug || groupSlug) as DlGroupSlug;

  if (!gSLug || !DL_GROUP_DESCRIPTION[gSLug]) {
    return <></>;
  }

  const navElements: NavElement[] = [
    { path: `/g/${gSLug}`, title: DL_GROUP_DESCRIPTION[gSLug].linkLabel },
    {
      path: `/g/${gSLug}/kd`,
      title: "izložbeni katalozi",
    },
    {
      path: `/g/${gSLug}/d`,
      title: "knjige",
    },
    {
      path: `/g/${gSLug}/p`,
      title: "periodika",
    },
    {
      path: `/g/${gSLug}/hm`,
      title: "hemeroteka",
    },
    {
      path: `/g/${gSLug}/photo-series/ph`,
      title: "fotodokumentacija",
    },
    {
      path: `/g/${gSLug}/photo-series/ng`,
      title: "neknjižna građa",
    },
  ];

  const navItems = navElements.map((navEl: NavElement, ind: number) => (
    <MainNavItem
      navElement={{
        path: navEl.path,
        title: navEl.title,
      }}
      key={`main_nav_el_${ind}`}
    />
  ));

  return (
    <>
      <MainNavGroup>{navItems}</MainNavGroup>
      <DotsLine />
    </>
  );
}
